
export default {
  profileSelector: {
    'activeProfile': 'Aktív'
  }
}
